const HASHTAG_REGEX = /#[\p{L}\p{N}_]+/gu;

const MAX_TITLE_LENGTH = 60;

const cleanTitleText = (text = "") => {
  return text
    // Emoji, piktogramy, strzałki itp.
    .replace(
      /[\p{Emoji_Presentation}\p{Extended_Pictographic}\p{S}]/gu,
      " "
    )

    // Variation selectors, zero-width joiner i podobne
    .replace(/[\uFE0E\uFE0F\u200B-\u200D\u2060]/gu, "")

    // Wszystkie rodzaje spacji, w tym NBSP
    .replace(/[\s\u00A0]+/gu, " ")

    // Usuń z początku wszystko aż do pierwszej litery/cyfry
    // np. "#  Absolwenci" -> "Absolwenci"
    .replace(/^[^\p{L}\p{N}]+/u, "")

    .trim();
};
const hasMeaningfulText = (text = "") => {
  return /[\p{L}\p{N}]/u.test(text);
};
const findSentencePeriod = (text) => {
  for (let i = 0; i < text.length; i += 1) {
    if (text[i] !== ".") {
      continue;
    }

    const previousChar = text[i - 1];
    const nextChar = text[i + 1];

    // Kropka wewnątrz daty/liczby, np. 12.08.2026
    if (
      /\d/.test(previousChar || "") &&
      /\d/.test(nextChar || "")
    ) {
      continue;
    }

    return i;
  }

  return -1;
};

const createTitle = (text) => {
  const value = text.trim();

  if (!value) {
    return "";
  }

  const sentencePeriodIndex = findSentencePeriod(value);

  if (
    sentencePeriodIndex !== -1 &&
    sentencePeriodIndex < MAX_TITLE_LENGTH
  ) {
    return value.slice(0, sentencePeriodIndex + 1);
  }

  if (value.length <= MAX_TITLE_LENGTH) {
    return value;
  }

  const shortened = value
    .slice(0, MAX_TITLE_LENGTH)
    .replace(/\s+\S*$/, "")
    .trim();

  return `${shortened}…`;
};

export const getFacebookPostTitle = (post = {}) => {
  const message = post.excerpt?.trim() || "";

  if (!message) {
    return post.title || "Post z Facebooka";
  }

  const textWithoutHashtags = message
    .replace(HASHTAG_REGEX, " ")
    .replace(/[\uFE0E\uFE0F\u200B-\u200D\u2060]/gu, "")
    .replace(/[\s\u00A0]+/gu, " ")
    .trim();

  if (!textWithoutHashtags) {
    return "Post z Facebooka";
  }

  const cleanText = cleanTitleText(textWithoutHashtags);

  if (!cleanText || !hasMeaningfulText(cleanText)) {
    return "Post z Facebooka";
  }

  return createTitle(cleanText);
};